import React from "react";
import { InputRangeRow } from "./index";
// Used by Heli KV2008B and Heli KV2019B machines

export default function DecelerationTimeRow() {
   return (
      <InputRangeRow
         titleProp={"Deceleration Time"}
         descriptionProp={"secs"}
         sizeProp={6}
         colSizeProp={6}
         typeProp={"text"}
         minProp={5}
         maxProp={120}
         propertyNameProp={"deceleration"}
         errorDialogueProp={"5-120 only"}
         floatProp={false}
      />
   );
}
